import type {
  AbstractControl,
  ValidationErrors,
  ValidatorFn,
} from '@angular/forms';
import type { OnyxTimeRange } from '@onyx/angular';
import { Duration } from 'luxon';
import { DurationHelper } from '../../../../common/helpers/duration.helper';
import type { OrderPointCategory } from '../enums/order-point-category';

export const orderTimeWindowDurationValidator =
  (
    category: OrderPointCategory.LOADING | OrderPointCategory.UNLOADING,
    serviceTime: number | null,
  ): ValidatorFn =>
  (control: AbstractControl<OnyxTimeRange | null>): ValidationErrors | null => {
    const value = control.value;
    if (!value || serviceTime == null) return null;

    const { from, to } = value;
    const duration = Duration.fromISOTime(to).minus(Duration.fromISOTime(from));
    const serviceTimeDuration = Duration.fromObject({ seconds: serviceTime });

    return duration < serviceTimeDuration
      ? {
          [`orderTimeWindowDuration.${category}`]: {
            serviceTime: DurationHelper.format(serviceTimeDuration),
          },
        }
      : null;
  };
